import SamlLogin from './SamlLogin'
export { SamlLogin }
export default SamlLogin



// WEBPACK FOOTER //
// ./src/pages/SamlLogin/index.js